<template>
  <a-date-picker
      v-show="info.status === 'edit'"
      v-model:value="data[propName]"
      :format="widget.format || 'YYYY-MM-DD'"
      :placeholder="'请选择' + info.title"
      valueFormat="x"
  />
  <div v-show="info.status === 'show'" class="view">
    <date-table :data="data" v-bind="$props"/>
  </div>
</template>


<script lang="ts" setup>
import {defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import DateTable from "./DateTable.vue";
import {DateFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: DateFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
